import React, { useState } from "react";

const Level1Question = ({ question, remainingSeconds, submitting, onSubmit }) => {
  const [selected, setSelected] = useState(null);

  const handleSubmit = () => {
    if (selected === null) return;
    onSubmit({ selectedIndex: selected });
    setSelected(null);
  };

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-8 max-w-2xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <span className="text-xs uppercase tracking-widest text-emerald-300">
          {question.category}
        </span>
        <span className="text-2xl font-black text-yellow-300">
          ⏱ {remainingSeconds ?? "--"}s
        </span>
      </div>

      <h2 className="text-xl lg:text-2xl font-bold text-white mb-1">
        {question.payload.text}
      </h2>

      {question.payload.textTranslated && (
        <h3 className="text-base lg:text-lg font-semibold text-cyan-200 mb-4">
          {question.payload.textTranslated}
        </h3>
      )}

      {question.payload.visual && (
        <div className="text-3xl lg:text-4xl font-mono text-center py-6 mb-4 rounded-2xl bg-black/30">
          {question.payload.visual}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-4">
        {question.payload.options.map((opt, idx) => (
          <button
            key={idx}
            onClick={() => setSelected(idx)}
            className={`rounded-xl px-5 py-4 text-left border transition-all ${
              selected === idx
                ? "bg-emerald-500/30 border-emerald-400"
                : "bg-white/5 border-white/10 hover:bg-white/10"
            }`}
          >
            <div>{opt}</div>
            {question.payload.optionsTranslated?.[idx] && (
              <div className="text-sm text-cyan-200 mt-1">
                {question.payload.optionsTranslated[idx]}
              </div>
            )}
          </button>
        ))}
      </div>

      <button
        onClick={handleSubmit}
        disabled={selected === null || submitting}
        className="w-full mt-6 rounded-2xl py-4 bg-gradient-to-r from-emerald-500 to-green-600 font-bold text-lg disabled:opacity-40"
      >
        {submitting ? "Submitting..." : "Submit Answer"}
      </button>
    </div>
  );
};

export default Level1Question;
